export const SORT_TYPE = {
  ASCENDING: "ascending",
  DESCENDING: "descending",
  DEFAULT: "default"
};
